<section class="bms-theme-content">
  <vdw-editor-header
    [identifier]="HEADER_IDENTIFIER"
    [menuItems]="[selectedMenuItem]"
    [selectedMenuItem]="selectedMenuItem"
    [canShowSettings]="false"
    [isCreateNewPage]="!isEditingRejectReason()"
    [inProgress]="saving"
    [canShowSave]="!navigationHelper.contentSwitcherDialogActive()"
    (duplicateEvent)="duplicateRejectReason()"
    (deleteEvent)="deleteRejectReason()"
    (cancelEvent)="navigateBack()"
    (saveEvent)="saveRejectReason(SAVE_TYPE.SAVE)"
    (saveAndCloseEvent)="saveRejectReason(SAVE_TYPE.SAVE_AND_CLOSE)"
    (saveAndCreateNewEvent)="saveRejectReason(SAVE_TYPE.SAVE_AND_CREATE_NEW)"
  ></vdw-editor-header>
  <div class="bms-theme flex-column p-48">
    <form [formGroup]="addRejectReasonForm" class="flex-column gap-8" vdwBp.gt-sm="pr-32 half-width" vdwBp.lt-sm="full-width" appBreadcrumbFormLinker>
      <div class="flex-row gap-16">
        <vdw-string-input [label]="'GENERAL.NAME' | bmsTranslate" [placeholder]="'GENERAL.MY_OBJECT' | bmsTranslate: {object: 'GENERAL.NAME' | bmsTranslate | lowercase}" formControlName="name">
          <ng-container error>
            <vdw-invalid-form-message *vdwCanShowErrorForFormControl="'name'; error: 'required'" [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
            <vdw-invalid-form-message
              *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'"
              [message]="'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate"
              [link]="getLoadLink()"
              [loadEntry]="getLoadEntry()"
              [compact]="true"
            ></vdw-invalid-form-message> </ng-container
        ></vdw-string-input>
        <div class="full-width flex-row gap-16">
          <vdw-color-picker-form-input [(selectedColor)]="addRejectReasonForm.get('color').value"></vdw-color-picker-form-input>
          <div class="flex-column">
            <p class="b2 font-weight-regular pt-4 pb-4">{{ 'BMSCONFIG.REJECT_REASON.REJECT_TYPE.REJECT_TYPE' | bmsTranslate }}</p>
            <mat-radio-group formControlName="rejectType" class="flex-row gap-16 pt-8 pb-8">
              <mat-radio-button [value]="REJECT_TYPE.REJECT">{{ 'BMSCONFIG.REJECT_REASON.REJECT_TYPE.REJECT' | bmsTranslate }}</mat-radio-button>
              <mat-radio-button [value]="REJECT_TYPE.WASTE">{{ 'BMSCONFIG.REJECT_REASON.REJECT_TYPE.WASTE' | bmsTranslate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="flex-row gap-16">
        <mat-form-field class="full-width">
          <mat-label>{{ 'GENERAL.CODE' | bmsTranslate }}</mat-label>
          <input matInput type="number" vdwL10nDecimal min="1" formControlName="code" [placeholder]="'GENERAL.MY_OBJECT' | bmsTranslate: {object: 'GENERAL.CODE' | bmsTranslate | lowercase}" />
          @if (addRejectReasonForm.controls?.code.value) {
            <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="addRejectReasonForm.controls?.code.reset()">
              <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
            </button>
          }
          <mat-error *vdwCanShowErrorForFormControl="'code'; error: 'required'">
            <vdw-invalid-form-message [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
          </mat-error>
          <mat-error *vdwCanShowErrorForFormControl="'code'; error: 'min'">
            <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1}" [compact]="true"></vdw-invalid-form-message>
          </mat-error>
          <mat-error *vdwCanShowErrorForFormControl="'code'; error: 'max'">
            <vdw-invalid-form-message [message]="'GENERAL.ERRORS.MAX_VALUE' | bmsTranslate: {max: MAX_CODE_VALUE}" [compact]="true"></vdw-invalid-form-message>
          </mat-error>
          <mat-error *vdwCanShowErrorForFormControl="'code'; error: 'identifierTaken'">
            <vdw-invalid-form-message [message]="'GENERAL.ERRORS.CODE_DUPLICATE' | bmsTranslate" [link]="getLoadLink('code')" [compact]="true"></vdw-invalid-form-message>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
          <mat-label>{{ 'BMSCONFIG.REJECT_REASON.DISPLAY_ORDER' | bmsTranslate }}</mat-label>
          <input matInput type="number" vdwL10nDecimal min="0" formControlName="displayOrder" placeholder="1" />
          @if (addRejectReasonForm.controls?.displayOrder.value) {
            <button class="clear-input-button" tabindex="-1" mat-icon-button type="button" (click)="addRejectReasonForm.controls?.displayOrder.reset()">
              <mat-icon svgIcon="solid-close" class="icon-12"></mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <div class="flex-row gap-16">
        <mat-form-field class="full-width">
          <mat-label>
            {{ 'BMSCONFIG.REJECT_REASON.MACHINE_TYPES' | bmsTranslate }}
          </mat-label>
          <vdw-object-selection
            formControlName="machineTypes"
            [objectName]="'MACHINE.SETTINGS.MACHINE_TYPES' | bmsTranslate | lowercase"
            [canShowBMSTheme]="true"
            [withDialogObjectSelection]="true"
            [refreshObjectSelection]="refreshObjectSelection"
            (selectClicked)="selectMachineTypes()"
            (clearClicked)="resetCodeAsyncValidator()"
          ></vdw-object-selection>
          <mat-error *vdwCanShowErrorForFormControl="'machineTypes'; error: 'required'">
            <vdw-invalid-form-message [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
          </mat-error>
        </mat-form-field>
        <div class="full-width">
          <mat-form-field class="full-width" *appHasPermission="REJECT_REASON_GROUP_PERMISSION">
            <mat-label>{{ 'GENERAL.GROUP' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection
              formControlName="group"
              [objectName]="'GENERAL.GROUP' | bmsTranslate: {count: 1} | lowercase"
              [canShowMultiSelectPlaceHolder]="false"
              [canShowBMSTheme]="true"
              [withDialogObjectSelection]="true"
              (selectClicked)="selectGroup()"
            ></vdw-object-selection>
          </mat-form-field>
        </div>
      </div>

      <vdw-string-input [label]="'GENERAL.DESCRIPTION' | bmsTranslate" [placeholder]="'GENERAL.DESCRIPTION_PLACEHOLDER' | bmsTranslate" formControlName="description"> </vdw-string-input>
    </form>
  </div>
</section>
